export const environment = {
  production: true,
  env: 'Production',
  ApiUrl: 'https://dmxhthapi.clavisco.com/', 
};
